import React from "react";
import { Link } from "react-router-dom";
import { FiInbox } from "react-icons/fi";
import "./SaaSUIToolkit.css";

export const SaaSEmptyState = ({
  icon = <FiInbox />,
  title = "No data found",
  description = "There are no records to display at this time.",
  actionLabel,
  actionLink,
  onAction,
}) => {
  return (
    <div className="saas-empty-state">
      <div className="saas-empty-state__icon-wrap">{icon}</div>
      <h3 className="saas-empty-state__title">{title}</h3>
      <p className="saas-empty-state__description">{description}</p>
      {actionLabel && actionLink && (
        <Link to={actionLink} className="saas-btn saas-btn--primary">
          {actionLabel}
        </Link>
      )}
      {actionLabel && !actionLink && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="saas-btn saas-btn--primary"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default SaaSEmptyState;
